import React, { useEffect, useState } from 'react';

import { Breakpoints, TextAppearance } from '@vw-marketing/us-components';

import { useVehicleManagement } from './hooks/useVehicleManagement';
import { useTrackingManager } from '../../shared/hooks/use-tracking-manager';
import { onVWBasicStepLoadEvent } from '../../shared/tagging/tagging-helpers';
import PageContainer from '../../shared/components/page-container';
import {
  useVehicleManagementLayers,
  VehicleManagementMode,
} from './layer-manager/useVehicleManagementLayers';

const VehicleManagement: React.FC = () => {
  const [garageLayerActive, setGarageLayerActive] = useState(false);
  const [addVehicleLayerActive, setAddVehicleLayerActive] = useState(false);
  const [nicknameLayerActive, setNicknameLayerActive] = useState(false);
  const [removeVehicleLayerActive, setRemoveVehicleLayerActive] = useState(false);

  const activeMode: VehicleManagementMode =
    garageLayerActive ? 'garage'
    : addVehicleLayerActive ? 'addVehicle'
    : nicknameLayerActive ? 'nickname'
    : removeVehicleLayerActive ? 'removeVehicle'
    : null;

  const handleLayerClose = () => {
    setGarageLayerActive(false);
    setAddVehicleLayerActive(false);
    setNicknameLayerActive(false);
    setRemoveVehicleLayerActive(false);
  };

  useVehicleManagementLayers({ mode: activeMode, onClose: handleLayerClose });

  const { cardsOrTabItem } = useVehicleManagement(
    () => setAddVehicleLayerActive(true),
    () => setGarageLayerActive(true),
    () => setNicknameLayerActive(true),
    () => setRemoveVehicleLayerActive(true),
  );

  const trackingManager = useTrackingManager();

  // Track page load event when component mounts
  useEffect(() => {
    try {
      // Call VWBasic_Step_Load event when vehicle management page loads
      onVWBasicStepLoadEvent(trackingManager, {
        Name: 'Vehicle Management',
        StepName: 'Vehicle Details',
        StepNumber: '5',
      });
    } catch (error) {
      console.warn('Error tracking vehicle management page load:', error);
    }
  }, [trackingManager]);

  return (
    <>
    <PageContainer
      labelKey="vehicleManagement"
      upperBreakpoint={Breakpoints.b560}
      textAppearance={TextAppearance.headline400}
    >
      {cardsOrTabItem}
    </PageContainer>
    </>
  );
};

export default VehicleManagement;
